export default __webpack_public_path__ + "static/media/profile.97618415.svg";